// extracted by mini-css-extract-plugin
export default {"contact":"styles_contact__8J6fd"};